export default function getLastPlayedVideo(firstVideo) {
  const lastPlayedVideo = localStorage.getItem("lastPlayedVideo");

  if (!lastPlayedVideo && firstVideo) {
    const param = firstVideo?.id;
    localStorage.setItem("lastPlayedVideo", JSON.stringify(param));
    return param;
  } else {
    const localParam = JSON.parse(lastPlayedVideo);
    return localParam;
  }
}
